import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/frontend/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { NunitoSans } from 'Shared/frontend/fonts/NunitoSans';
import { Imbue } from 'Shared/frontend/fonts/Imbue';
import { NoticiaText} from 'Shared/frontend/fonts/NoticiaText';


export class LucillesSettings extends BaseSettings
{

	palette()
	{
		return {
			background: '#000000',
			text: 'white',
			feature: '#F5A3BE', //pink

			/* Eg the mobile nav colour */
			dimBackground: '#000000',

			food: '', 
			drinks: '',
			
			// CJ added: needed to change scrollBar colors for light theme
			scrollBar: {
			//	scrollbarColor: '#fdfae7 #f6e9d2 !important',
			}
		};
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					color: this.palette().feature,
					backgroundColor: '#232323',
				},
			}
		});
	}

	fontIncludes()
	{
		return [
			NunitoSans,
			NoticiaText,
			Imbue
		];
	}

	fonts() {
		return {
			text: '"Nunito Sans", sans-serif',
			teaser: '"Imbue", serif',
			heading: '"Noticia Text", serif',
			tagline: '"Nunito Sans", sans-serif',
			buttons: '"Nunito Sans", sans-serif',
			desktopNav: '"Nunito Sans", sans-serif',
			menuItem: '"Noticia Text", serif',
	mobileNav: '"Nunito Sans", sans-serif',
			subNav: '"Nunito Sans", sans-serif',
		};
	}

	
	page()
	{
		return merge(super.page(), {
			heading: {
				color: this.palette().feature,
			},
			section: {
				title: {
					color: this.palette().feature,
					fontWeight: '700',
					fontSize:'clamp(1.8rem, 4vw, 3rem)!important',
				//	letterSpacing: 3, 
					textTransform: 'initial',
				},

			
				teaser:{
					color: this.palette().feature,
					fontFamily: this.fonts().teaser,
					fontWeight: '500',
					fontSize:'clamp(1.2rem, 5vw, 3rem)!important',	
				},
				tagline:{
					color: this.palette().feature,
					fontFamily: this.fonts().tagline,
					fontWeight: '300 !important',
					fontSize:'clamp(1.2rem, 5vw, 2rem)!important',	
				},
			},

			widgets: {
				subNav: {
					button: {
						backgroundColor: this.palette().background,
						color: this.palette().feature,
				border: 'solid 3px',
				borderColor: this.palette().feature,
					}
				}
			},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
			},
		});
	}


	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		const settings = merge(base, <DeepPartial<BaseThemeType>>{
			event: {
				artist: {
					heading: {
						color: palette.feature,
						fontFamily: 'sans-serif'
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature
						}
					}, 
					genresAndLocation: {
						color: palette.feature
					} 
				}
			},

	//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
	menu: {
		subNav: {
			button: {
				color: palette.feature,
				border: 'solid 3px',
				borderColor: palette.feature,
			},
			buttonType: type => ({ backgroundColor: palette.background })
		},
		section: {
			heading: {
				fontFamily: this.fonts().menuItem,
				fontSize:'clamp(2rem, 4vw, 3.5rem)!important',
				color: palette.feature,
			},
		},
		item: {
			type: 'imageless',
			title: { 
				fontFamily: this.fonts().menuItem,
				fontSize: '1.3em',
			},
		},
	},

			subNavButton: {
				borderRadius: '0.4em',
				color: palette.feature,
				border: 'solid 3px',
				borderColor: palette.feature,
			},
		});

		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}
};

